// src/config.js
const BACKEND_URL = "https://sparematepartner.com:8000";
const BASE_URL = BACKEND_URL + "/api";
export default BASE_URL;
export { BACKEND_URL };